import React, { Fragment } from 'react';
import { defaultFormat } from '../../../Utils/DateFormat';
import { numberFormat, capitalize, formatPrice } from '../../../Utils/Common';
import Pagination from 'react-js-pagination';
import DynamicFont from 'react-dynamic-font';
import { Link } from 'react-router-dom';
import { Table } from 'react-bootstrap';

export class BlitzDefaultContentCustom extends React.PureComponent {
    // function SalesOrderPrintContent({ so, auth }) {
    // let subId = auth.user.subscriber_id;
    constructor(props) {
        super(props);
        this.divScrollRef = React.createRef();

        let img_url = '/app-assets/images/logo/sample-logo.png';
        const tableRows = this.renderExtrRow(this.props.print_rows);
        let totalItemsCount = this.props.so.sales_order_items.length;

        // Set itemsCountPerPage to 5 if the totalItemsCount is 7, 15, 23, or 31
        let itemsCountPerPage;

        // 1–6 items → same number of rows
        if (totalItemsCount >= 1 && totalItemsCount <= 6) {
            itemsCountPerPage = totalItemsCount;

            // Exact-fit cases → 7 rows
        } else if ([7, 15, 23, 31].includes(totalItemsCount)) {
            itemsCountPerPage = 7;

            // Default → 8 rows
        } else {
            itemsCountPerPage = 8;
        }

        this.state = {
            so: this.props.so,
            auth: this.props.auth,
            activePage: 1,
            itemsCountPerPage: itemsCountPerPage,
            totalItemsCount: totalItemsCount,
            pageRangeDisplayed: 5,
            img_url: img_url,
            tableRows: tableRows,
            print: this.props.print,
            subs_setting: this.props.subs_setting,
        };
    }

    renderExtrRow(numberOfRows) {
        const tableRows = [];
        for (var i = 0; i < numberOfRows; i++) {
            tableRows.push(
                <tr key={'tr-' + i}>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                </tr>
            );
        }

        return tableRows;
    }

    handlePageChange(pageNumber) {
        this.setState({ activePage: pageNumber });
        this.divScrollRef.current.scrollIntoView();
    }

    renderPrint(page, totalPage) {
        // console.log(page, totalPage);
        const { so } = this.state;

        // --- pagination bounds for this page ---
        const totalItemsCount = so.sales_order_items.length;
        var showItemsToRaw = page * this.state.itemsCountPerPage;
        var showItemsFrom = showItemsToRaw - this.state.itemsCountPerPage;
        var showItemsTo = showItemsToRaw - 1;

        // Build slice for current page
        const visibleItems = so.sales_order_items.slice(
            showItemsFrom,
            showItemsTo + 1
        );

        // Count how many filler rows are needed to keep uniform table height
        // Last page: no filler rows (save spacing)
        const isLastPage = page === totalPage;
        let extraRowsCount = isLastPage
            ? 0
            : this.state.itemsCountPerPage - visibleItems.length;
        if (extraRowsCount < 0) extraRowsCount = 0;

        let auth = this.state.auth;

        let subId = '5fbce7782151301e660fa0d4';

        let img_url =
            auth.user.subscriber_id == subId
                ? '/monaki.png'
                : '/app-assets/images/logo/sample-logo.png';
        let company =
            auth.user.subscriber_id == subId ? 'Monikki Enterprises' : '';
        let address =
            auth.user.subscriber_id == subId
                ? '7i Bellagio 3 Forbestown Rd cor Burgos Circle BGC Taguig'
                : '';
        let contact = auth.user.subscriber_id == subId ? '02-7368-2071' : '';
        let email =
            auth.user.subscriber_id == subId
                ? 'mysecret.ph23@gmail.com.com'
                : '';
        let img_class =
            auth.user.subscriber_id == subId
                ? 'print-logo temp-logo'
                : 'print-logo';
        let temp_footer =
            auth.user.subscriber_id == subId ? (
                <div className="col-md-12">
                    <div className="f-14b temp-div pt-1 pb-2">
                        <div className="f-12">
                            {company} | {address} | {contact} | {email}{' '}
                        </div>
                    </div>
                </div>
            ) : (
                <div className="col-md-6 col-print-6">
                    <ul className="f-16b ul-print-paw">
                        <li>Phone #</li>
                        <li>Address</li>
                        <li>Website</li>
                    </ul>
                </div>
            );

        const customerAddress = [
            so.customer.street1,
            so.customer.street2 && ', ',
            so.customer.street2,
            (so.customer.street1 || so.customer.street2) && ', ',
            so.customer.city,
            so.customer.city && so.customer.state && ', ',
            so.customer.state,
        ]
            .filter(Boolean)
            .join('');

        // const { company_name, company_address, company_landline, company_email } = this.state.subs_setting;
        const subs_setting = this.state.subs_setting;
        const currencyDisplay =
            subs_setting &&
            subs_setting.currency &&
            subs_setting.currency.code &&
            subs_setting.currency.code.checked
                ? 'code'
                : 'symbol';
        const template_setting = this.state.so.template_setting;

        const dotMatrixStyle = {
            fontFamily: '"Courier New", Courier, monospace',
            fontSize: '16px',
            lineHeight: '1.2',
            whiteSpace: 'pre-wrap', // ✅ allow wrapping (pre but wrap)
            overflowWrap: 'anywhere', // ✅ break very long words
            wordBreak: 'break-word', // ✅ older browsers
            padding: '20px',
            boxSizing: 'border-box',
            width: '100%',
        };

        const headerLineLength = this.props.print === '1' ? 99 : 80;
        const headerLine = Array(headerLineLength).fill('.').join('');

        // Common "no overflow" text style for long lines (address + item sublines)
        const noOverflowText = {
            whiteSpace: 'pre-wrap',
            overflowWrap: 'anywhere',
            wordBreak: 'break-word',
        };

        // Item name bold, sku/brand/description: bold + font size 10 (no overflow)
        const itemNameStyle = {
            fontWeight: 'bold',
            ...noOverflowText,
        };

        const itemSubStyle = {
            fontSize: '12px',
            lineHeight: '1.25',
            ...noOverflowText,
        };

        // For the Item column to wrap nicely inside tableLayout: fixed
        const itemCellStyle = {
            ...noOverflowText,
        };

        // fixed width columns so numbers align better + prevent table overflow
        const colNo = { width: '5%' };
        const colItem = { width: '45%' };
        const colPrice = { width: '12%' };
        const colUnit = { width: '10%' };
        const colQty = { width: '8%' };
        const colTotal = { width: '20%' };

        console.log('so', so);
        return (
            <div
                className="dr-print"
                style={{
                    ...dotMatrixStyle,
                    // extra top padding so the title isn't clipped by the
                    // printer's unprintable top margin on any page
                    paddingTop: '50px',
                    // ensure each page breaks correctly when printing multiple pages
                    pageBreakAfter: page === totalPage ? 'auto' : 'always',
                }}
            >
                <div style={{ textAlign: 'center', width: '100%' }}>
                    *** DELIVERY RECEIPT ***
                </div>
                <div>{headerLine}</div>

                <div className="mt-2" style={{ fontSize: '18px' }}>
                    {template_setting?.company_name}
                </div>
                <div className="mt-1" style={noOverflowText}>
                    <strong>Address:</strong>{' '}
                    {template_setting?.company_address}
                </div>
                <div style={noOverflowText}>
                    <strong>Mobile #:</strong>{' '}
                    {template_setting?.company_mobile}
                </div>
                <div style={noOverflowText}>
                    <strong>Tel:</strong> {template_setting?.company_landline}
                </div>
                <div style={noOverflowText}>
                    <strong>Email:</strong> {template_setting?.company_email}
                </div>

                <div>{headerLine}</div>

                <div className="d-flex mt-2">
                    <div style={{ flex: 1 }}>
                        <div style={noOverflowText}>
                            <div>
                                <strong>Customer:</strong>{' '}
                                <Link
                                    to={`/sales/customers/history/${
                                        so.customer ? so.customer._id : null
                                    }`}
                                    className="txt-underline"
                                    target="_blank"
                                >
                                    {so.customer ? so.customer.name : null}
                                </Link>
                            </div>
                            <div style={noOverflowText}>
                                <strong>Customer Address:</strong>{' '}
                                {customerAddress}
                            </div>
                        </div>

                        <div className="mt-1" style={noOverflowText}>
                            <strong>SO #:</strong> {so.sales_order_no}
                        </div>
                        <div style={noOverflowText}>
                            <strong>Reference #:</strong> {so.reference_no}
                        </div>
                        <div style={noOverflowText}>
                            <strong>Date:</strong>{' '}
                            {defaultFormat(so.sales_order_date)}
                        </div>

                        {so.status == 'draft' ? (
                            <div className="mt-1" style={noOverflowText}>
                                <strong>STATUS:</strong> DRAFT
                            </div>
                        ) : (
                            ''
                        )}
                    </div>
                    <div
                        style={{
                            borderLeft: '1px dotted #000',
                            margin: '0 12px',
                            alignSelf: 'stretch',
                        }}
                    />
                    <div style={{ flex: 1 }}>
                        <div style={noOverflowText}>
                            <strong>Payment Details:</strong>{' '}
                            {so.payment_mode?.label}
                        </div>
                        <div
                            className="mt-1"
                            style={{
                                ...noOverflowText,
                                whiteSpace: 'pre-line',
                            }}
                        >
                            {so.payment_details}
                        </div>
                    </div>
                </div>

                <div>{headerLine}</div>

                {/* ✅ Delivery-like dot matrix table (simple) but NO OVERFLOW */}
                <Table
                    bordered={false}
                    size="sm"
                    className="mt-3"
                    style={{
                        borderCollapse: 'collapse',
                        tableLayout: 'fixed', // ✅ force column widths
                        width: '100%',
                    }}
                >
                    <thead
                        style={{
                            border: 'none',
                            borderBottom: '1px dotted #000',
                        }}
                    >
                        <tr>
                            <th className="p-1" style={colNo}>
                                #
                            </th>
                            <th className="p-1" style={colItem}>
                                Item Description
                            </th>
                            <th className="p-1 text-right" style={colPrice}>
                                Price
                            </th>
                            <th className="p-1 text-center" style={colUnit}>
                                Unit
                            </th>
                            <th className="p-1 text-right" style={colQty}>
                                Qty
                            </th>
                            <th className="p-1 text-right" style={colTotal}>
                                Total
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {visibleItems.map((item, idx) => {
                            const unitPrice = item.unit_price
                                ? item.unit_price
                                : item.srp;

                            return (
                                <tr key={showItemsFrom + idx}>
                                    <td className="p-1" style={noOverflowText}>
                                        {showItemsFrom + idx + 1}
                                    </td>

                                    {/* ✅ product_name bold, sku/brand/desc bold size 10, no overflow */}
                                    <td className="p-1" style={itemCellStyle}>
                                        <div style={itemNameStyle}>
                                            {item.product_name}
                                        </div>

                                        {item.sku != null ? (
                                            <div style={itemSubStyle}>
                                                {item.sku}
                                            </div>
                                        ) : null}

                                        {item.description != null ? (
                                            <div style={itemSubStyle}>
                                                {item.description}
                                            </div>
                                        ) : null}

                                        {item.brand != null ? (
                                            <div style={itemSubStyle}>
                                                {item.brand}
                                            </div>
                                        ) : null}

                                        {item.discount_type &&
                                        item.discount_type.value !== 'none' ? (
                                            <div style={itemSubStyle}>
                                                Discount: {item.discount}
                                                {item.discount_type.label ===
                                                'Percent'
                                                    ? ' %'
                                                    : ''}{' '}
                                                |(-
                                                {numberFormat(
                                                    Number(
                                                        item.discount_amount
                                                    ).toFixed(2)
                                                )}
                                                )
                                            </div>
                                        ) : null}
                                    </td>

                                    <td
                                        className="p-1 text-right"
                                        style={noOverflowText}
                                    >
                                        {formatPrice(
                                            unitPrice,
                                            currencyDisplay
                                        )}
                                    </td>

                                    <td
                                        className="p-1 text-center"
                                        style={noOverflowText}
                                    >
                                        {item.product_unit_name
                                            ? item.product_unit_name
                                            : ''}
                                    </td>

                                    <td
                                        className="p-1 text-right"
                                        style={noOverflowText}
                                    >
                                        {item.qty}
                                    </td>

                                    <td
                                        className="p-1 text-right"
                                        style={noOverflowText}
                                    >
                                        {formatPrice(
                                            item.amount,
                                            currencyDisplay
                                        )}
                                    </td>
                                </tr>
                            );
                        })}

                        {this.renderExtrRow(extraRowsCount)}
                    </tbody>
                </Table>

                {/* <div>{headerLine}</div> */}

                {/* Only show totals + terms on last page (same behavior as original) */}
                {page == totalPage ? (
                    <Fragment>
                        <div className="d-flex justify-content-between mt-2">
                            <div>
                                <div style={noOverflowText}>
                                    <strong>Payment Terms:</strong>{' '}
                                    {so.payment_terms?.label}
                                </div>
                                <div className="mt-1" style={noOverflowText}>
                                    <strong>Terms and Condition:</strong>{' '}
                                    {so.terms_and_condition}
                                </div>

                                <div className="mt-1" style={noOverflowText}>
                                    <strong>Additional Remarks:</strong>{' '}
                                    {so.remarks}
                                </div>
                            </div>

                        </div>
                        <div className="mt-2">{headerLine}</div>

                        <div className="mt-1" style={noOverflowText}>
                            <strong>Sub Total:</strong>
                            <span style={{ float: 'right' }}>
                                {formatPrice(so.sub_total, currencyDisplay)}
                            </span>
                        </div>

                        {so.discount_type.value === '' ? (
                            ''
                        ) : (
                            <div className="mt-1" style={noOverflowText}>
                                <strong>
                                    Discount{' '}
                                    {so.discount &&
                                    so.discount_type.value === 'percent'
                                        ? `(${numberFormat(so.discount, 0)}%)`
                                        : ''}
                                    :
                                </strong>
                                <span style={{ float: 'right' }}>
                                    {so.discount &&
                                    so.discount_type.value === 'percent'
                                        ? formatPrice(
                                              so.sub_total *
                                                  (so.discount / 100),
                                              currencyDisplay
                                          )
                                        : formatPrice(
                                              so.discount,
                                              currencyDisplay
                                          )}
                                </span>
                            </div>
                        )}

                        {so.tax_type.value === 'none' ? (
                            ''
                        ) : (
                            <div className="mt-1" style={noOverflowText}>
                                <strong>
                                    VAT{' '}
                                    {so.tax
                                        ? `(${numberFormat(so.tax, 0)}%)`
                                        : ''}
                                    :
                                </strong>
                                <span style={{ float: 'right' }}>
                                    {formatPrice(
                                        so.vat_amount,
                                        currencyDisplay
                                    )}
                                </span>
                            </div>
                        )}

                        {so.other === 0 ? (
                            ''
                        ) : (
                            <div className="mt-1" style={noOverflowText}>
                                <strong>Delivery Fee:</strong>
                                <span style={{ float: 'right' }}>
                                    {formatPrice(so.other, currencyDisplay)}
                                </span>
                            </div>
                        )}

                        <div className="mt-1" style={noOverflowText}>
                            <strong style={{ fontSize: '18px' }}>TOTAL:</strong>
                            <span style={{ float: 'right', fontSize: '18px' }}>
                                {formatPrice(so.total, currencyDisplay)}
                            </span>
                        </div>

                        <div className="mt-2">{headerLine}</div>

                        <div className="d-flex justify-content-between mt-2">
                            <div style={noOverflowText}>
                                <strong>Prepared by:</strong>{' '}
                                <div> {so.user_prepared_by}</div>
                            </div>
                            <div style={noOverflowText}>
                                <strong>Checked by:</strong>{' '}
                                <div> {so.user_checked_by}</div>
                            </div>
                            <div style={noOverflowText}>
                                <strong>Approved by:</strong>{' '}
                                <div> {so.user_approved_by}</div>
                            </div>
                        </div>
                    </Fragment>
                ) : (
                    void 0
                )}

                {/* <div className="mt-2">{headerLine}</div> */}

                <div className="mt-1" style={{ textAlign: 'right' }}>
                    Page {page}/{totalPage}
                </div>
            </div>
        );
    }

    renderMultiplePage() {
        const tableRows = [];
        const tableRowsTry = [];
        let numberOfPage = Math.ceil(
            this.state.totalItemsCount / this.state.itemsCountPerPage
        );
        for (let i = 1; i <= numberOfPage; i++) {
            tableRows.push(this.renderPrint(i, Math.floor(numberOfPage)));
        }
        return tableRows;
    }

    render() {
        let so = this.state.so;

        let numberOfPage = Math.ceil(
            this.state.totalItemsCount / this.state.itemsCountPerPage
        );

        return (
            <Fragment>
                {/*
                <div className="temp-watermark">
                    <h1>{so.status == 'draft' ? so.status : ''}</h1>
                </div>
            */}
                <div ref={this.divScrollRef} className="main-print-div">
                    {this.state.print == 0 ? (
                        this.renderPrint(this.state.activePage, numberOfPage)
                    ) : (
                        <Fragment>{this.renderMultiplePage()}</Fragment>
                    )}{' '}
                </div>

                <div className="hidden-print d-flex justify-content-center pagination-print">
                    <Pagination
                        className="pagination"
                        itemClass="page-item"
                        linkClass="page-link"
                        activePage={this.state.activePage}
                        itemsCountPerPage={this.state.itemsCountPerPage}
                        totalItemsCount={this.state.totalItemsCount}
                        pageRangeDisplayed={this.state.pageRangeDisplayed}
                        onChange={this.handlePageChange.bind(this)}
                    />
                </div>
            </Fragment>
        );
    }
}

// const mapStateToProps = state => ({
// 	single_sales_order: state.sales_order.single_sales_order,
// 	auth: state.auth
// })

export default BlitzDefaultContentCustom;
